import util from '../util'

let controller = 'ParceiroOperacaoContabil'
export default Object.assign({}, util.GetCrud(controller, null))
